import { Analytics } from './analyticsModelSchema';

export const CoyoteRepeatingEventSelector = {
    viewed: ({ isFlagEnabled }) =>
        Analytics.event({
            object: 'CoyoteRepeatingEventSelector',
            action: 'Viewed',
            properties: {
                isFlagEnabled: {
                    type: 'label',
                    value: isFlagEnabled,
                },
            },
        }),
};

export const Event = {
    created: ({ eventId }) =>
        Analytics.event({
            object: 'Event',
            action: 'Created',
            properties: {
                eventId: {
                    type: 'dimension',
                    value: eventId,
                },
            },
        }),
    discarded: () =>
        Analytics.event({
            object: 'Event',
            action: 'Discarded',
        }),
    saved: ({ eventId }) =>
        Analytics.event({
            object: 'Event',
            action: 'Saved',
            properties: {
                eventId: {
                    type: 'dimension',
                    value: eventId,
                },
            },
        }),
    previewed: () =>
        Analytics.event({
            object: 'Event',
            action: 'Previewed',
        }),
    published: () =>
        Analytics.event({
            object: 'Event',
            action: 'Published',
        }),
    unpublished: () =>
        Analytics.event({
            object: 'Event',
            action: 'Unpublished',
        }),
    deleted: () =>
        Analytics.event({
            object: 'Event',
            action: 'Deleted',
        }),
    cancelled: () =>
        Analytics.event({
            object: 'Event',
            action: 'Cancelled',
        }),
    copied: () =>
        Analytics.event({
            object: 'Event',
            action: 'Copied',
        }),
    viewed: () =>
        Analytics.event({
            object: 'Event',
            action: 'Viewed',
        }),
};

export const EventSchedule = {
    created: ({ scheduleId }) =>
        Analytics.event({
            object: 'EventSchedule',
            action: 'Created',
            properties: {
                scheduleId: {
                    type: 'label',
                    value: scheduleId,
                },
            },
        }),
};

export const TicketClass = {
    created: () =>
        Analytics.event({
            object: 'TicketClass',
            action: 'Created',
        }),
    saved: () =>
        Analytics.event({
            object: 'TicketClass',
            action: 'Saved',
        }),
    deleted: () =>
        Analytics.event({
            object: 'TicketClass',
            action: 'Deleted',
        }),
};

export const OrderForm = {
    saved: () =>
        Analytics.event({
            object: 'OrderForm',
            action: 'Saved',
        }),
};

export const Question = {
    enabled: Analytics.event({
        object: 'Question',
        action: 'Enabled',
    }),
    disabled: Analytics.event({
        object: 'Question',
        action: 'Disabled',
    }),
};

export const CustomQuestion = {
    saved: () =>
        Analytics.event({
            object: 'CustomQuestion',
            action: 'Saved',
        }),
    deleted: () =>
        Analytics.event({
            object: 'CustomQuestion',
            action: 'Deleted',
        }),
};

export const Waitlist = {
    saved: () =>
        Analytics.event({
            object: 'Waitlist',
            action: 'Saved',
        }),
};

export const Facebook = {
    clicked: () =>
        Analytics.event({
            object: 'Facebook',
            action: 'Clicked',
        }),
};

export const FacebookTicketClass = {
    added: () =>
        Analytics.event({
            object: 'FacebookTicketClass',
            action: 'Added',
        }),
    removed: () =>
        Analytics.event({
            object: 'FacebookTicketClass',
            action: 'Removed',
        }),
};

export const APO = {
    saved: () =>
        Analytics.event({
            object: 'APO',
            action: 'Saved',
        }),
};

// TBD
export const EmailInvitations = {};
export const DiscountAndAccessCodes = {};
export const WebsiteIntegrations = {};
export const TrackingLinks = {};
export const TrackingPixels = {};
export const AffiliatePrograms = {};
